import { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Button from "../../components/common/Button/Button";
import Badge from "../../components/common/Badge/Badge";
import { FiDownload, FiPlay, FiUsers } from "react-icons/fi";
import { MdEuroSymbol } from "react-icons/md";
import { getApiInstance } from "../../utils/api";
import Table from "../../components/common/Table/Table";
import {
    CiCircleCheck,
    CiCircleInfo,
    CiClock1,
    CiWarning,
} from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import MapComponent from "../../components/common/MapComponent/MapComponent";
import { useZone } from "../../context/ZoneContext";
import "./CentrosProductores.scss";
import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
import { mapList } from "../../utils/utils";
import { IoStopOutline } from "react-icons/io5";
import { LuWeight } from "react-icons/lu";
import { formatDate } from "../../utils/utils";
import { useTranslation } from "react-i18next";

export default function CentrosProductores({ user }) {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("listado");
    const [obras, setObras] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();
    const [intermediarios, setIntermediarios] = useState([]);
    const [cadenas, setCadenas] = useState([]);
    const [tiposCentro, setTiposCentro] = useState([]);
    const [comunidades, setComunidades] = useState([]);
    const [paises, setPaises] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [promotores, setPromotores] = useState([]);
    const [usuariosIntermediarios, setUsuariosIntermediarios] = useState([]);
    const [productores, setProductores] = useState([]);
    const [selectedObras, setSelectedObras] = useState(new Set());

    const columnasCentrosProductores = [
        { key: "codObra", label: "ID", visible: false },
        {
            key: "codEspacio",
            label: t("productionCenters.columns.spaceCode"),
            visible: true,
            sortable: true,
            isLink: true,
            render: (row) => {
                const href = `/centros-productores/${row.codObra}`;
                return (
                    <Link to={href}>
                        <span className="table-cell-content__primary table-cell-content__primary--bold">
                            {row.codEspacio}
                        </span>
                    </Link>
                );
            },
        },
        // {
        //     key: "nombre",
        //     label: t("productionCenters.columns.workCode"),
        //     visible: true,
        //     sortable: true,
        //     visibleOnExpand: true,
        // },
        {
            key: "direccion",
            label: t("fields.address"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        // {
        //     key: "fechaInicio",
        //     label: t("fields.startDate"),
        //     visible: true,
        //     sortable: true,
        //     type: "date",
        //     visibleOnExpand: true,
        // },
        // {
        //     key: "fechaFin",
        //     label: t("fields.endDate"),
        //     visible: true,
        //     sortable: true,
        //     type: "date",
        //     visibleOnExpand: true,
        // },
        {
            key: "intermediario",
            label: t("fields.intermediary"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        // {
        //     key: "cadena",
        //     label: t("fields.chain"),
        //     visible: true,
        //     sortable: true,
        //     visibleOnExpand: true,
        // },
        {
            key: "tipoObra",
            label: t("productionCenters.columns.centerType"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
        {
            key: "codEstado",
            label: t("fields.state"),
            visible: true,
            sortable: true,
            visibleOnExpand: true,
        },
    ];

    const formElementsCentrosProductores = [
        {
            title: t("sections.generalInfo"),
            titleVisible: "true",
            elements: [
                {
                    name: "codProductor",
                    type: "select",
                    label: t("fields.producer"),
                    placeholder: t("productionCenters.form.selectProducer"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: productores,
                },
                {
                    name: "codTipoObra",
                    type: "select",
                    label: t("productionCenters.columns.centerType"),
                    placeholder: t("productionCenters.form.selectCenterType"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: tiposCentro,
                },
                {
                    name: "codEspacio",
                    type: "text",
                    label: t("productionCenters.columns.spaceCode"),
                    placeholder: t("placeholders.enterName"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codigoObra",
                    type: "text",
                    label: t("productionCenters.columns.workCode"),
                    placeholder: t("placeholders.enterName"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codIntegracion",
                    type: "text",
                    label: t("fields.integrationCode"),
                    placeholder: t("placeholders.enterIntegrationCode"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                // {
                //     name: "fechaInicio",
                //     type: "date",
                //     label: t("fields.startDate"),
                //     placeholder: t(
                //         "placeholders.selectDate"
                //     ),
                //     required: false,
                //     disabled: false,
                //     labelVisible: true,
                //     visible: true,
                // },
                // {
                //     name: "fechaFin",
                //     type: "date",
                //     label: t("fields.endDate"),
                //     placeholder: t(
                //         "placeholders.selectDate"
                //     ),
                //     required: false,
                //     disabled: false,
                //     labelVisible: true,
                //     visible: true,
                // },
                {
                    name: "nima",
                    type: "text",
                    label: t("fields.NIMA"),
                    placeholder: t("placeholders.enterNIMA"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                // {
                //     name: "codCadena",
                //     type: "select",
                //     label: t("fields.chain"),
                //     placeholder: t(
                //         "productionCenters.form.selectChain"
                //     ),
                //     required: false,
                //     disabled: false,
                //     labelVisible: true,
                //     visible: true,
                //     options: cadenas,
                // },
                {
                    name: "codZona",
                    type: "number",
                    label: t("productionCenters.form.zone"),
                    visible: false,
                    defaultValue: selectedZone.value,
                },
            ],
        },
        {
            title: t("productionCenters.form.responsibles"),
            titleVisible: true,
            elements: [
                {
                    name: "codIntermediario",
                    type: "select",
                    label: t("fields.intermediary"),
                    placeholder: t("productionCenters.form.selectIntermediary"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: intermediarios,
                },
                {
                    name: "codUsuario",
                    type: "select",
                    label: t("fields.users"),
                    placeholder: t("productionCenters.form.selectUser"),
                    options: usuariosIntermediarios,
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codIntermediario",
                },
                {
                    name: "responsable",
                    type: "text",
                    label: t("productionCenters.form.responsible"),
                    placeholder: t("productionCenters.form.enterResponsible"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "mailResponsable",
                    type: "text",
                    label: t("productionCenters.form.emailResponsible"),
                    placeholder: t(
                        "productionCenters.form.enterEmailResponsible"
                    ),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
            ],
        },
        {
            title: t("sections.location"),
            titleVisible: true,
            elements: [
                {
                    name: "direccion",
                    type: "text",
                    label: t("fields.address"),
                    placeholder: t("placeholders.enterAddress"),
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codPais",
                    type: "select",
                    label: t("fields.country"),
                    placeholder: t("placeholders.selectCountry"),
                    options: paises,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codComunidad",
                    type: "select",
                    label: t("fields.community"),
                    placeholder: t("placeholders.selectCommunity"),
                    options: comunidades,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codPais",
                },
                {
                    name: "codProvincia",
                    type: "select",
                    label: t("fields.province"),
                    placeholder: t("placeholders.selectProvince"),
                    options: provincias,
                    required: true,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    associatedFormElement: "codComunidad",
                },
                {
                    name: "localidad",
                    type: "text",
                    label: t("fields.locality"),
                    placeholder: t("placeholders.enterLocality"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "cp",
                    type: "text",
                    label: t("fields.postalCode"),
                    placeholder: t("placeholders.enterPostalCode"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "codZona",
                    type: "number",
                    label: t("productionCenters.form.zone"),
                    visible: false,
                    defaultValue: selectedZone.value,
                },
            ],
        },
        {
            title: t("productionCenters.form.centerData"),
            titleVisible: true,
            elements: [
                {
                    name: "codUbicacion",
                    type: "select",
                    label: t("fields.location"),
                    placeholder: t("productionCenters.form.selectLocation"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: [
                        {
                            label: "Calle",
                            value: "1",
                            id: 1,
                        },
                        {
                            label: "Centro comercial",
                            value: "2",
                            id: 2,
                        },
                    ],
                },
                {
                    name: "superficie",
                    type: "number",
                    label: t("productionCenters.form.surface"),
                    placeholder: t("productionCenters.form.enterSurface"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "promotor",
                    type: "select",
                    label: t("productionCenters.form.promoter"),
                    placeholder: t("productionCenters.form.selectPromoter"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                    options: promotores,
                },
                {
                    name: "kilometros1",
                    type: "number",
                    label: t("productionCenters.form.transportMaterialSupply"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "kilometros2",
                    type: "number",
                    label: t("productionCenters.form.transportWasteManagement"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
                {
                    name: "observaciones",
                    type: "textarea",
                    label: t("fields.observations"),
                    placeholder: t("productionCenters.form.enterObservation"),
                    required: false,
                    disabled: false,
                    labelVisible: true,
                    visible: true,
                },
            ],
        },
    ];

    const filterFields = [
        {
            key: "codEspacio",
            label: t("productionCenters.columns.spaceCode"),
            type: "multiselect",
        },
        { key: "nombre", label: t("fields.name"), type: "multiselect" },
        { key: "direccion", label: t("fields.address"), type: "multiselect" },
        {
            key: "intermediario",
            label: t("fields.intermediary"),
            type: "multiselect",
        },
        { key: "cadena", label: t("fields.chain"), type: "multiselect" },
        {
            key: "tipoObra",
            label: t("productionCenters.columns.centerType"),
            type: "multiselect",
        },
    ];

    const cumlimientosStates = [
        { label: "states.noData", type: "info", Icon: CiClock1 },
        { label: "states.pending", type: "info", Icon: CiClock1 },
        { label: "states.incident", type: "warning", Icon: CgDanger },
        { label: "states.validated", type: "success", Icon: CiCircleCheck },
    ];

    const tabs = [
        { id: "listado", label: t("productionCenters.tabs.list") },
        { id: "mapa", label: t("productionCenters.tabs.map") },
    ];

    const selectedItems = useMemo(
        () => obras.filter((obra) => selectedObras.has(obra.codObra)),
        [obras, selectedObras]
    );

    // Función para obtener el porcentaje de valorización único para cada centro
    const getValorizacionStatus = (centro) => {
        // Si viene el porcentaje real de la API, usarlo
        if (
            centro.porcentajeValorizacion !== undefined &&
            centro.porcentajeValorizacion !== null
        ) {
            return Math.max(0, Math.min(100, centro.porcentajeValorizacion));
        }

        // Generar porcentaje único basado en el ID del centro
        const id = centro.codObra || centro.id || centro.codEspacio || "0";
        let hash = 0;
        const str = id.toString();

        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash; // Convert to 32bit integer
        }

        // Convertir hash a porcentaje entre 0-100
        const percentage = Math.abs(hash) % 101;
        return percentage;
    };

    // Función para obtener el estado de cumplimiento
    const getCumplimientoStatus = (centro) => {
        switch (centro.codEstado) {
            case "COMPLETADO":
            case "VALIDADO":
                return {
                    status: t("states.validated"),
                    variant: "success",
                    Icon: CiCircleCheck,
                };
            case "INCIDENCIA":
            case "RETRASADO":
                return {
                    status: t("states.incident"),
                    variant: "danger",
                    Icon: CgDanger,
                };
            case "PENDIENTE":
            case "EN_PROGRESO":
                return {
                    status: t("states.pending"),
                    variant: "warning",
                    Icon: CiWarning,
                };
            default:
                return {
                    status: t("states.noData"),
                    variant: "outlined",
                    Icon: CiCircleInfo,
                };
        }
    };

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
    };

    const fetchObras = async () => {
        setLoading(true);
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Obra/GetObrasFromZona/${selectedZone.value}/1/es`
            );

            setObras(response.data);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las obras. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchIntermediarios = async () => {
        const api = getApiInstance();
        try {
            let intermediariosData = [];

            const response = await api.get(
                `/api/Intermediarios/GetIntermediariosByZona/${selectedZone.value}`
            );
            intermediariosData = response.data;

            setIntermediarios([
                ...mapList(intermediariosData, "nombre", "codIntermediario"),
            ]);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchCadenas = async () => {
        const api = getApiInstance();
        try {
            let cadenasData = [];

            const response = await api.get(`/api/Cadenas/GetAllCadenas`);
            cadenasData = response.data;

            setCadenas([
                ...mapList(cadenasData, "cadena", "codCadena", "codCadena"),
            ]);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchTiposObra = async () => {
        const api = getApiInstance();
        try {
            let tiposObraData = [];

            const response = await api.get(`/api/ObrasTipo/GetAllObrasTipo`);
            tiposObraData = response.data;

            setTiposCentro([
                ...mapList(
                    tiposObraData,
                    "descripcion",
                    "codTipoObra",
                    "codTipoObra"
                ),
            ]);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchComunidades = async () => {
        const api = getApiInstance();

        try {
            let comunidadesData = [];

            const response = await api.get(
                `/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`
            );
            comunidadesData = response.data;

            setComunidades(
                mapList(
                    comunidadesData,
                    "comunidad",
                    "codComunidad",
                    "codComunidad",
                    "codPais"
                )
            );

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchPaises = async () => {
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaisesByZona/${selectedZone.value}`
            );
            paisesData = response.data;

            setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchProvincias = async () => {
        const api = getApiInstance();
        try {
            let provinciasData = [];

            const response = await api.get(
                `/api/Provincias/GetProvinciasByZona/${selectedZone.value}`
            );
            provinciasData = response.data;

            setProvincias(
                mapList(
                    provinciasData,
                    "provincia",
                    "codProvincia",
                    "codProvincia",
                    "codComunidad"
                )
            );
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchPromotores = async () => {
        const api = getApiInstance();
        try {
            let promotoresData = [];

            const response = await api.get(`/api/Promotor/GetPromotores`);
            promotoresData = response.data;

            setPromotores(
                mapList(promotoresData, "promotor", "promotor", "promotor")
            );
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    const fetchUsuariosIntermediarios = async () => {
        const api = getApiInstance();
        try {
            let usuariosIntermediariosData = [];

            const response = await api.get(
                `/api/Usuario/GetAllUsuariosIntermediarios/${selectedZone.value}`
            );
            usuariosIntermediariosData = response.data;

            setUsuariosIntermediarios(
                mapList(
                    usuariosIntermediariosData,
                    ["nombre", "apellidos"],
                    "codUsuario",
                    "codIntermediario",
                    "codIntermediario"
                )
            );
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchProductores = async () => {
        const api = getApiInstance();
        try {
            let productoresData = [];

            const response = await api.get(
                `/api/Productores/GetProductoresByZona/${selectedZone.value}`
            );
            productoresData = response.data;

            setProductores([
                ...mapList(productoresData, "nombre", "codProductor"),
            ]);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las provincias. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
        }
    };

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        setError(null);

        const loadAll = async () => {
            try {
                await fetchObras();

                await Promise.all([
                    fetchIntermediarios(),
                    fetchCadenas(),
                    fetchTiposObra(),
                    fetchPaises(),
                    fetchComunidades(),
                    fetchProvincias(),
                    fetchPromotores(),
                    fetchUsuariosIntermediarios(),
                    fetchProductores(),
                ]);
            } catch (err) {
                if (isMounted) {
                    setError(
                        "No se han podido cargar los datos. Vuelve a intentarlo más tarde."
                    );
                }
                console.error("Error en loadAll:", err);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        loadAll();

        return () => {
            isMounted = false;
        };
    }, [selectedZone]);

    const modalMap = (centro) => {
        return (
            <div className="centro-map-details">
                <div className="centro-header">
                    <h3 className="centro-title">
                        {centro.nombre || centro.codEspacio || ""},{" "}
                        {centro.direccion || ""}
                    </h3>
                </div>

                <div className="centro-info-section">
                    <div className="info-row">
                        <FiPlay className="info-icon" />
                        <span className="info-label">
                            {t("fields.startDate")}
                        </span>
                        <span className="info-value">
                            {formatDate(centro.fechaInicio) || ""}
                        </span>
                    </div>
                    <div className="info-row">
                        <IoStopOutline className="info-icon" />
                        <span className="info-label">
                            {t("fields.endDate")}
                        </span>
                        <span className="info-value">
                            {formatDate(centro.fechaFin) || ""}
                        </span>
                    </div>

                    <div className="info-row info-row--highlight">
                        <FiUsers className="info-icon" />
                        <span className="info-label">
                            {t("fields.intermediary")}
                        </span>
                        <span className="info-value intermediario-link">
                            {centro.intermediario || ""}
                        </span>
                    </div>

                    <div className="info-row">
                        <LuWeight className="info-icon" />
                        <span className="info-label">
                            {t("nav.generatedQuantities")}
                        </span>
                        <span className="info-value">{centro.peso || ""}</span>
                    </div>

                    <div className="info-row">
                        <MdEuroSymbol className="info-icon" />
                        <span className="info-label">{t("nav.costs")}</span>
                        <span className="info-value">
                            {centro.costeTotal || ""}
                        </span>
                    </div>
                </div>

                <div className="centro-valorizacion-section">
                    <h4 className="section-title">
                        {t("sheets.center.charts.valorization")}
                    </h4>
                    <div className="valorizacion-percentage">
                        {(centro.peso
                            ? (centro.valorizacion / centro.peso) * 100
                            : 0
                        ).toFixed(2)}
                        %
                    </div>
                    <ProgressBar
                        percentage={
                            (centro.peso
                                ? (centro.valorizacion / centro.peso) * 100
                                : 0
                            ).toFixed(2) || 0
                        }
                        height={8}
                        width="100%"
                    />
                </div>

                <div className="centro-cumplimiento-section">
                    <div className="cumplimiento-header">
                        <h4 className="section-title">
                            {t("sections.legalCompliance")}
                        </h4>
                        <Badge
                            variant={getCumplimientoStatus(centro).variant}
                            Icon={getCumplimientoStatus(centro).Icon}
                        >
                            {getCumplimientoStatus(centro).status}
                        </Badge>
                        {centro.cumplimientos.map((cumplimiento, index) => (
                            <div key={index} className="cumplimiento-item">
                                <span className="cumplimiento-name">
                                    {cumplimiento.nombre || ""}
                                </span>
                                <Badge
                                    variant={
                                        cumlimientosStates[
                                            cumplimiento.codEstado
                                        ]?.type || "info"
                                    }
                                >
                                    {t(
                                        cumlimientosStates[
                                            cumplimiento.codEstado
                                        ]?.label
                                    ) || t("states.noData")}
                                </Badge>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="modal-actions">
                    <Button
                        variant="filled"
                        onClick={() => {
                            window.location.href = `/centros-productores/${centro.codObra}`;
                        }}
                    >
                        {t("common.view")} {t("sheets.center.title")}
                    </Button>
                </div>
            </div>
        );
    };

    const renderTabContent = () => {
        switch (activeTab) {
            case "listado":
                return (
                    <Table
                        columns={columnasCentrosProductores}
                        dataTable={obras}
                        showCheckboxes={true}
                        noResultsMessage={t("productionCenters.noCentersFound")}
                        actions={["Editar"]}
                        searchTerms={[
                            t("productionCenters.columns.spaceCode"),
                            t("productionCenters.columns.workCode"),
                            t("fields.address"),
                            t("fields.intermediary"),
                            t("fields.chain"),
                            t("productionCenters.columns.centerType"),
                        ]}
                        keyProp="codObra"
                        expandable={true}
                        elementName={t("productionCenters.title")}
                        stateProp="codEstado"
                        sortProp="codEspacio"
                        states={[
                            {
                                label: t("states.noData"),
                                type: "info",
                                Icon: CiClock1,
                            },
                            {
                                label: t("states.pending"),
                                type: "info",
                                Icon: CiClock1,
                            },
                            {
                                label: t("states.incident"),
                                type: "warning",
                                Icon: CgDanger,
                            },
                            {
                                label: t("states.validated"),
                                type: "success",
                                Icon: CiCircleCheck,
                            },
                            {
                                label: t("states.noData"),
                                type: "info",
                                Icon: CiCircleCheck,
                            },
                            {
                                label: t("states.expired"),
                                type: "danger",
                                Icon: CiCircleCheck,
                            },
                            {
                                label: t("states.active"),
                                type: "primary",
                                Icon: CiCircleCheck,
                            },
                        ]}
                        filterFields={filterFields}
                        loading={loading}
                        formElements={
                            user.role == 1 ? formElementsCentrosProductores : []
                        }
                        addApiUrl="/api/Obra/SetObra"
                        editApiUrl="/api/Obra/UpdateObra"
                        selectedRows={selectedObras}
                        onSelectionChange={setSelectedObras}
                        userCodAcceso={Number(user.codAcceso)}
                        userCodPerfil={Number(user.role)}
                    />
                );
            case "mapa":
                return (
                    <MapComponent
                        data={obras}
                        center={[42.0, 2.0]}
                        zoom={5}
                        height="600px"
                        width="100%"
                        modalContent={modalMap}
                    />
                );
            default:
                return null;
        }
    };

    const handleExportarSeleccionados = () => {
        if (selectedItems.length === 0) {
            alert("Por favor, selecciona al menos un centro para exportar.");
            return;
        }

        const codigosDeObras = selectedItems.map((item) => item.codObra);

        generateExcel({ codsProveedores: codigosDeObras });
    };

    const generateExcel = async ({ codsProveedores }) => {
        const api = getApiInstance();
        const codZona = selectedZone.value;
        const codZonaLegal = selectedZone.value;

        try {
            const response = await api.post(
                "/api/Proveedores/CreateReportByCods",
                codsProveedores,
                {
                    params: { codZona, codZonaLegal },
                    responseType: "blob",
                }
            );

            const contentDisposition = response.headers["content-disposition"];
            let fileName = "Informe_Proveedores.xlsx";
            if (contentDisposition) {
                const fileNameMatch =
                    contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch.length === 2) {
                    fileName = fileNameMatch[1];
                }
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            setError(
                "No se pudo generar el reporte. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        }
    };

    return (
        <PageLayout
            title={t("productionCenters.title")}
            subtitle={t("productionCenters.subtitle")}
        >
            <TabsNavigation
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />
            {renderTabContent()}
        </PageLayout>
    );
}
